/**
 * The one glyph set for tone'd feedback — StatusBanner and Toast draw the same
 * four icons so "success" looks like success wherever it appears. Paths are
 * 16×16, stroke-only.
 */
export type Tone = 'success' | 'error' | 'warning' | 'info';

export const TONE_ICON_PATHS: Record<Tone, string> = {
  success: 'M3 8.5 6.5 12 13 4.5',
  error: 'M4 4l8 8M12 4l-8 8',
  warning: 'M8 2 14.5 13H1.5L8 2zM8 6.5v3M8 11.5h.01',
  info: 'M8 7.5v4M8 4.5h.01M14 8a6 6 0 1 1-12 0 6 6 0 0 1 12 0z',
};

/** An error interrupts (`alert`); everything else waits its turn (`status`). */
export const TONE_ROLE: Record<Tone, 'alert' | 'status'> = {
  success: 'status',
  error: 'alert',
  warning: 'status',
  info: 'status',
};
